import React, { useEffect, useState, Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import navbarStore from '@/store/navbar';
import InfiniteScroll from 'react-infinite-scroll-component';
import globalStore from '@/store/global';
import { debounce } from 'lodash-es';
import { HelpOther, HelperCore } from '@/common/helper';
import { useParams } from 'react-router-dom';
import chatStoreManager from '@/store/chat/manager';
import appLogger from '@public/log/monitor';
import { useMemo } from 'react';
import { sendBroadcast, useBroadcast } from '@/hooks/useBroadcast';
import { AssistantType } from '@shared/constants/chat';
import DeleteMenu from './delete-mune';
import deleteMenuStore from './delete-mune/store';
import AppCheckBox from '@/ui/checkbox';
import { Dropdown } from 'antd';
import IconButton from '../chat-history/IconButton';
import EE from '@/common/event';
import { useRef } from 'react';
import { request } from '@/common';
import Loader from '@/common/helper/loader';
import ModelHistory from './model-history';
import inputTypeStore from '../input-file/input-type';
import slsLogger from '@public/log/sls';
import userStore from '@/store/user';
import ScrollView from '@/ui/scroll-view';
import LoginBtn from './login-btn';
import AigentHistory from './aigent-history';

let requesting = false;
const RenameInput = ({ item, setShowRenameInput }) => {
  const [text, setText] = useState(item.alias_title || item.title);
  const ref = useRef(null);

  const doEdit = () => {
    const conversation_id = item.conversation_id;
    const alias_name = ref.current.value;
    if (!alias_name.trim()) return;
    if (requesting) return;
    requesting = true;
    request
      .post('/conversation/edit/alias', {
        conversation_id,
        alias_name,
      })
      .then(res => {
        if (res.code == 0) {
          setShowRenameInput(false);
          navbarStore.updateAliasTitle(conversation_id, alias_name);
          sendBroadcast('history-changed');
        } else {
          HelpOther.toast('修改失败', 'error');
        }
        requesting = false;
      })
      .catch(() => {
        requesting = false;
        HelpOther.toast('修改失败', 'error');
      });
  };

  const handleKeyDown = event => {
    //回车提交
    if (event.keyCode == 13) {
      doEdit();
    }
    //ESC退出编辑模式
    if (event.keyCode == 27) {
      setShowRenameInput(false);
    }
  };

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, [ref]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="relative">
      <input
        ref={ref}
        value={text}
        onChange={evt => {
          setText(evt.target.value);
        }}
        onBlur={evt => {
          doEdit();
          setShowRenameInput(false);
        }}
        className="h-40px w-full text-14px text-black leading-40px border-1px border-black rounded-12px px-12px"
      />
    </div>
  );
};

const dropList = (item, isCur, setShowDropdown, setShowRenameInput) => {
  const conversation_id = item.conversation_id;
  const isTopUp = item.pin_top_time; //有pin_top_time字段就认为是置顶了
  const action = isTopUp ? '2' : '1'; //1 置顶操作 2 取消置顶
  return (
    <div
      className={`w-[150px] px-[8px] py-[8px] rounded-[12px] flex flex-col ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
      style={{
        boxShadow: '0px 2px 8px 0px #0000001A',
        border: '1px solid rgba(0,0,0,0.1)',
      }}
    >
      <div
        className={`w-full h-[40px] rounded-[8px] font-bold text-[14px] text-[#000] flex items-center cursor-pointer hover:bg-[#000] hover:bg-opacity-4 ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
        onClick={evt => {
          const params = {
            conversation_id,
            action,
          };
          slsLogger.log({
            key : "chat",
            action : "pinTopConversation",
            ext : JSON.stringify(params),
          });
          request
            .post('/conversation/edit/pin_top', params)
            .then(res => {
              if (res.code == 0) {
                navbarStore.updateTopUp(
                  conversation_id,
                  isTopUp ? '' : +new Date()
                );
                sendBroadcast('history-changed');
              }
            })
            .catch(Loader.error);
          setShowDropdown(false);
          evt.stopPropagation();
        }}
      >
        <IconButton
          className="!hover:bg-transparent"
          icon={isTopUp ? 'topup_cancel' : 'topup'}
          size={20}
        ></IconButton>
        {isTopUp ? '取消置顶' : '置顶对话'}
      </div>
      <div
        className={`w-full h-[40px] rounded-[8px] font-bold text-[14px] text-[#000] flex items-center cursor-pointer hover:bg-[#000] hover:bg-opacity-4 ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
        onClick={evt => {
          setShowRenameInput(true);
          setShowDropdown(false);
          evt.stopPropagation();
        }}
      >
        <IconButton
          className="!hover:bg-transparent"
          icon="edit"
          size={20}
        ></IconButton>
        重命名
      </div>
      <div
        className={`w-full h-[40px] rounded-[8px] font-bold text-[14px] text-[#FF3B30] flex items-center cursor-pointer hover:bg-[#FEF5F6] ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-white'}`}
        onClick={evt => {
          setShowDropdown(false);
          HelpOther.confirm({
            title: '确认删除对话',
            okText: '删除',
            content: (
              <div className="whitespace-nowrap">
                确定要删除对话吗？删除后对话内容将不可恢复。
                {/* <div className='text-[#FF3B30]'>已加入知识库的对话将同步删除</div> */}
              </div>
            ),
            onOk: () => {
              if (isCur) {
                if (chatStoreManager.current?.isAITyping) {
                  chatStoreManager.current.abort(() => {
                    navbarStore.clearHistory(item.conversation_id, true);
                  });
                } else {
                  navbarStore.clearHistory(item.conversation_id, true);
                }
              } else {
                navbarStore.clearHistory(item.conversation_id);
              }
              // // 删除知识库
              // (async ()=> {
              //   try {
              //     const isProd = import.meta.env.MODE === 'master'
              //     const isPre = import.meta.env.MODE === 'online'
              //     await initSDK({
              //       env: isProd ? 'prod' : isPre ? 'hgtest' : 'test', // test: 测试环境 hgtest: 回归环境 prod: 生产环境
              //       qid: userStore.uid, // 用户qid
              //     })
              //     // const isExist = await checkChatExist(item.conversation_id)
              //     // if(!isExist) return
              //     await deleteChat(item.conversation_id); // 不返回任何内容，删除失败会抛错
              //     EE.emit('MyknowledgeChange')
              //   } catch (error) {
              //     // console.log('删除知识库失败');
              //   }
              // })()
              appLogger.log({
                key: 'aibot_home',
                action: 'click',
                arrt: 'del_chat',
                conversation_id: item.conversation_id,
              });
            },
          });
          evt.stopPropagation();
        }}
      >
        <IconButton
          className="!hover:bg-transparent"
          icon="icon_delete_dropdown"
          size={20}
        ></IconButton>
        删除对话
      </div>
    </div>
  );
};

const doClick = debounce((conversation_id, scene="") => {
  globalStore.navigate(`/${scene == "aigent" ? "agentchat" : "chat" }/${conversation_id}`, {
    state: { history: true },
  });
}, 300);

const ListItem = observer(({ item, scene="", id }) => {
  const isCur = item.conversation_id == id;
  const [showDropdown, setShowDropdown] = useState(false);
  const [showRenameInput, setShowRenameInput] = useState(false);

  useEffect(() => {
    EE.on('hide_list_dropdown', setShowDropdown);

    return () => {
      EE.off('hide_list_dropdown', setShowDropdown);
    };
  }, []);

  //编辑删除状态不显示未生成会话id的数据
  if (
    item.conversation_id == chatStoreManager.getVirtualId() &&
    deleteMenuStore.isEdit
  )
    return null;

  if (showRenameInput) {
    return <RenameInput item={item} setShowRenameInput={setShowRenameInput} />;
  }

  return (
    <div
      onClick={evt => {
        inputTypeStore.reset();
        if (deleteMenuStore.isEdit) {
          deleteMenuStore.toggleDeleteId(item.conversation_id);
          return;
        }
        if (isCur) return;
        doClick(item.conversation_id, scene);

        appLogger.log({
          key: 'aibot_home',
          action: 'click',
          arrt: 'chat_history',
          ext: appLogger.getSubContent(item.alias_title || item.title),
          conversation_id: item.conversation_id,
        });
      }}
      className={[
        'flex items-center cursor-pointer relative h-36px box-border',
        'pr-8px rounded-8px overflow-hidden',
        deleteMenuStore.isEdit ? 'pl-8px' : 'pl-8px',
        globalStore.isDark
          ? '!hover:bg-[#3D3D46] group'
          : '!hover:bg-[#00000008] group',
        isCur
          ? globalStore.isDark
            ? 'bg-[#282832]'
            : 'bg-gray-nav-hover'
          : '',
        showDropdown
          ? globalStore.isDark
            ? 'bg-[#3D3D46]'
            : 'bg-[#00000008]'
          : '',
      ]}
    >
      {
        <>
          {deleteMenuStore.isEdit ? (
            <AppCheckBox
              className="!w-16px !h-16px mr-10px cursor-poiter"
              checked={deleteMenuStore.deleteIds.includes(item.conversation_id)}
            />
          ) : null}
          <div className="flex-grow w-0 relative flex items-center">
            {navbarStore.chatModels[item.role_id]?.conversation_type == 1 ? (
              <span
                className={`flex-shrink-0 h-18px w-36px flex items-center justify-center font-bold mr-6px rounded-4px text-12px bg-[#1DAB69] bg-opacity-10 text-[#1DAB69]`}
              >
                画图
              </span>
            ) : null}
            {item?.chat_type === AssistantType.LocalModel ? (
              <span
                className={`flex-shrink-0 h-18px w-36px flex items-center justify-center font-bold mr-6px rounded-4px text-12px bg-[#0058FF] bg-opacity-10 text-[#0058FF] ${globalStore.isDark ? 'bg-[#2780FE] !bg-opacity-10 !text-[#2780FE]' : ''}`}
              >
                本地
              </span>
            ) : null}
            {item.chat_type === AssistantType.APIModel && (
              <span
                className={`flex-shrink-0 h-18px w-36px flex items-center justify-center font-bold mr-6px rounded-4px text-12px bg-[#E43F9F] bg-opacity-10 text-[#E43F9F]`}
              >
                API
              </span>
            )}
            {item.chat_type === AssistantType.PrivateModel && (
              <span
                className={`flex-shrink-0 h-18px w-36px flex items-center justify-center font-bold mr-6px rounded-4px text-12px bg-[#FF7307] bg-opacity-10 text-[#FF7307]`}
              >
                私有
              </span>
            )}
            <div className="w-full text-primary text-14px h-36px leading-36px truncate">
              {item.alias_title || item.title}
            </div>
          </div>

          {userStore.isUser && <div
            className={[
              'w-56px h-full flex items-center justify-end hidden absolute top-0 right-4px bottom-0 group-hover:flex',
              showDropdown ? '!flex' : '',
              deleteMenuStore.isEdit ||
              item.conversation_id == chatStoreManager.getVirtualId()
                ? '!hidden'
                : '',
            ]}
            style={{
              background: globalStore.isDark
                ? 'linear-gradient( 90deg, rgba(61,61,70,0) 0%, #3D3D46 35%, #3D3D46 100%)'
                : 'linear-gradient(90deg, rgba(238, 238, 238, 0.00) 3.13%, #EEE 36.46%)',
            }}
          >
            <Dropdown
              dropdownRender={() =>
                dropList(item, isCur, setShowDropdown, setShowRenameInput)
              }
              trigger="click"
              placement="bottomLeft"
              open={showDropdown}
              onOpenChange={visible => {
                setShowDropdown(visible);
              }}
            >
              <IconButton
                className={[
                  'hover:bg-[rgba(0,0,0,0.04)] !p-0',
                  'rounded-[6px]',
                  showDropdown ? '!bg-[rgba(0,0,0,0.04)]' : '',
                ]}
                iconClassName="text-[rgb(0,0,0,.5)]"
                icon="more"
                size={24}
                onClick={evt => {
                  evt.stopPropagation();
                }}
              />
            </Dropdown>
          </div>}
        </>
      }
    </div>
  );
});

const ChatHistory = observer(({ className, showSearchInput, scene="" }) => {
  const { getHistory, historyList: listData, historyNpt } = navbarStore;
  const { id } = useParams()

  const isBizUserLogin = useMemo(() => {
    return !!(userStore.bizLoginInfo && userStore.isUser);
  }, [userStore.bizLoginInfo, userStore.isUser]);

  useBroadcast('history-changed', data => {
    const id = chatStoreManager.currentId;
    getHistory(true, scene == "aigent" ? "6" : "5");
    if (
      ((data.isBatch
        ? data.removeId.split(',').includes(id)
        : data?.removeId === id) &&
        id) ||
      data.is_all
    ) {
      globalStore.gotoHome(true);
      chatStoreManager.setCurrentId(null);
    }
  });

  // 多端同步 - 机器人会话历史
  const handleHistory = (data) => {
    console.log('多端同步 - 会话', data);
    getHistory(true, scene == "aigent" ? "6" : "5");
  }
  useEffect(() => {
    EE.on("assistant_history", handleHistory);

    return () => {
      EE.off("assistant_history", handleHistory);
    }
  }, []);

  // 非登录状态下获取历史数据
  useEffect(() => {
    if (navbarStore.sourceId !== 1) {
      navbarStore.reset()
      getHistory(true, scene == "aigent" ? "6" : "5");
    }
  }, [navbarStore.sourceId]);

  // 修改 mixedArr 的计算逻辑
  const mixedArr = useMemo(() => {
    if (!listData) return [];

    // 按时间分组
    const groups = {};
    listData.forEach(item => {
      const group = HelperCore.getTimeGroup(item);
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(item);
    });

    // 构建最终数组
    const result = [];
    ['置顶', '今天', '昨天', '前天','最近7天', '更早'].forEach(group => {
      if (groups[group] && groups[group].length > 0) {
        result.push({
          type: 'group',
          title: group,
          update_time: groups[group][0].update_time,
        });
        result.push(...groups[group]);
      }
    });

    // 添加年份分组
    Object.keys(groups)
      .filter(group => group.includes('年'))
      .sort((a, b) => parseInt(b) - parseInt(a))
      .forEach(year => {
        result.push({
          type: 'group',
          title: year,
          update_time: groups[year][0].update_time,
        });
        result.push(...groups[year]);
      });
    //置顶排序，后置顶的在上面
    result.sort((a, b) => b.pin_top_time - a.pin_top_time);
    return result;
  }, [listData, listData?.length]);

  return (
    <>
      <div className={['relative flex flex-col h-0 flex-grow pr-4px', className]}
      style={{
        paddingBottom: deleteMenuStore.isEdit ? '98px':'',
      }}>
        <ScrollView
          scrollY
          id="history_wrap"
          className="h-0 flex-grow"
        >
          <InfiniteScroll
            dataLength={mixedArr?.length}
            next={() => {
              getHistory(false, scene == "aigent" ? "6" : "5");
            }}
            onScroll={evt => {
              EE.emit('hide_list_dropdown', false);
              deleteMenuStore.toggleDropdown(false);
            }}
            hasMore={!!historyNpt}
            loader={null}
            className="pl-8px"
            scrollableTarget="history_wrap"
          >
            {
              isBizUserLogin
              ? scene == "aigent"
              ? <AigentHistory />
              : <ModelHistory />
              : null
            }
            {isBizUserLogin && mixedArr.length ? (
              <>
                {userStore.isUser ? <div className="h-1px w-220px bg-[rgba(0,0,0,0.06)] mx-auto my-8px"></div> : null}
                <DeleteMenu
                  hideMore={
                    showSearchInput ||
                    !listData.filter(
                      item =>
                        item.conversation_id != chatStoreManager.getVirtualId()
                    ).length
                  }
                  scene={scene}
                />
              </>
            ) : null}
            {isBizUserLogin && mixedArr?.map((item, index, arr) => {
              // 日期分组信息
              if (item.type === 'group') {
                const isFirst = index == 0;
                if (index === arr.length - 1) return null;
                let next = arr[index + 1];
                if (next.type && next.type === 'group') return null;
                return (
                  <Fragment key={item.conversation_id || index}>
                    <div
                      className={[
                        'ml-8px  text-12px leading-32px text-[#00000080]',
                        globalStore.isDark ? '!text-[#FFFFFF80]' : '',
                        isFirst ? 'mt-6px' : 'mt-4px',
                      ]}
                    >
                      {item.title}
                    </div>
                  </Fragment>
                );
              }
              return (
                <ListItem
                  key={item.conversation_id || index}
                  item={item}
                  index={index}
                  scene={scene}
                  id={id}
                />
              );
            })}
            {
              !isBizUserLogin ? <LoginBtn className={"mt-16px ml-12px mr-8px"}/> : null
            }
          </InfiniteScroll>
        </ScrollView>
      </div>
    </>
  );
});
export default ChatHistory;
